// ============================================================================
// RPC / PostgREST error → human message.
//
// supabase-js v2 returns PostgrestError as a PLAIN OBJECT, not an Error
// instance. Code like `err instanceof Error ? err.message : 'X failed.'`
// therefore swallows every real database message behind the generic
// fallback — which is exactly how AFB-0029's "Cutover failed." hid a
// P0001 "Not authorized" / JWT-expiry error for days.
//
// AFB-0054 (2026-07-29): this helper now DELEGATES to describeError() in
// ./errors.ts rather than carrying its own copy of the unwrapping logic.
// describeError is the superset — it does everything this did, plus constraint
// translation. Keeping two near-identical unwrappers would guarantee they drift.
// Existing call sites are unchanged; they just get better messages.
// ============================================================================

import { describeError } from './errors';

export function rpcErrorMessage(err: unknown, fallback: string): string {
  return describeError(err, fallback).message;
}
